import * as Yup from 'yup'

const schema = Yup.object({
  runningText: Yup.string()
    .required('กรุณากรอกข้อความวิ่ง'),
  lineLink: Yup.string()
    .required('กรุณากรอกไลน์ ad')
});

export default schema